import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { IBreadcrumb } from 'projects/access-control/src/app/Domain/Entities/breabcumd.interface';
import { Client } from 'projects/access-control/src/app/Domain/Entities/client.interface';
import { DataTranslatePages } from 'projects/access-control/src/app/Domain/Entities/data-translate-pages';
import { ModuleClient } from 'projects/access-control/src/app/Domain/Entities/module-client.interface';
import { IPkSk } from 'projects/access-control/src/app/Domain/Entities/roles/role.interface';
import {
	deleteClient,
	deleteModuleOneClient,
	getClient,
	getModuleOneClient,
	searchClient,
} from 'projects/access-control/src/app/Infrastructure/Store/clients/clients.action';
import { selectClientState } from 'projects/access-control/src/app/Infrastructure/Store/clients/clients.selectors';
import { ModalAddModuleClientComponent } from 'projects/access-control/src/app/UI/components/modal-add-module-client/modal-add-module-client.component';
import { ModalNewClientComponent } from 'projects/access-control/src/app/UI/components/modal-new-client/modal-new-client.component';
import { TranslateService } from '@mangosoft/mango-layout';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

interface translateClients extends DataTranslatePages {
	buttonDelete: string;
	buttonEdit: string;
	cardModule: string;
	hoverButtonNew: string;
	textCode: string;
	textModules: string;
	textNotSelected: string;
	deleteClient: string;
	deleteModule: string;
	notSelecteClient: string;
	notFoundModule: string;
	buttonNewModule: string;
}
@Component({
	selector: 'app-clients',
	templateUrl: './clients.component.html',
	styleUrls: ['./clients.component.scss'],
})
export class ClientsComponent implements OnInit {
	clients: Client[] = [];
	openAlert = false;
	elementsDelete = '';
	valueModalDelete = '';
	loading = false;
	loadingModule = false;
	subscriptionClient!: Subscription;
	subscriptionTranslate!: Subscription;
	public clientSelect: Client = {} as Client;
	moduleSelect: ModuleClient = {} as ModuleClient;
	translateClients: translateClients = {} as translateClients;
	isClientSelect = false;
	isModuleSelect = false;
	clientSelectedDelete: IPkSk = {} as IPkSk;
	moduleClientDeleteSelected: ModuleClient = {} as ModuleClient;
	public searchClient: string;
	breadcrumb: IBreadcrumb[] = [];
	homeBreadcrumb: IBreadcrumb = { id: ['clientsView'], text: 'Clients' };

	constructor(
		private store: Store,
		public dialog: MatDialog,
		private translateService: TranslateService
	) {
		this.searchClient = '';
	}

	ngOnInit(): void {
		this.getTranslate();
		this.getClients();
		this.store.dispatch(getClient());
	}

	getTranslate() {
		//Se extrae los textos del translate para la vista de clientes.
		this.subscriptionTranslate = this.translateService.init('AccessControl').subscribe((data) => {
			this.translateClients = data.pages.clients;
			this.itemsClients(this.clients);
		});
	}
	ngOnDestroy() {
		//Eliminar subscripciones
		this.subscriptionTranslate?.unsubscribe();
		this.subscriptionClient?.unsubscribe();
	}
	openDialogclient(type?: string, client?: Client) {
		//Abrir modal de cliente
		const dialogRef = this.dialog.open(ModalNewClientComponent, {
			height: '510px',
			width: '800px',
			data: type ? client : {},
		});
	}
	openDialogAddModuleClient(event: any) {
		//Abrir modal para modulo del cliente
		const dialogRef = this.dialog.open(ModalAddModuleClientComponent, {
			height: '600px',
			width: '500px',
			data: this.clientSelect,
		});
	}
	getClients() {
		this.subscriptionClient = this.store
			.pipe(select(selectClientState))
			.subscribe(({ clients, loading, loadingModule }) => {
				if (clients.length > 0) {
					if (this.isClientSelect) {
						//Actualizo el cliente seleccionado si se hace una modificacion en este
						this.clientSelect = clients.find(
							(x) => x.pk === this.clientSelect.pk && x.sk === this.clientSelect.sk
						) as Client;
						this.clientSelect = {
							...this.clientSelect,
							module:
								this.clientSelect?.module.map((module) => {
									return {
										...module,
										logo: module?.logo ? module?.logo.replace('s3.amazonaws.com/', '') : '',
									};
								}) || [],
						};

						//Actualizo el modulo seleccionado si se hizo alguna modificacion en este
						this.moduleSelect =
							this.clientSelect.module.find(
								(moduleItem) =>
									moduleItem.moduleSk === this.moduleSelect.moduleSk &&
									moduleItem.modulePk === this.moduleSelect.modulePk
							) || ({} as ModuleClient);
						this.isModuleSelect = this.moduleSelect.custom_name_module ? true : false;
					}
					this.itemsClients(clients);
				} else {
					this.clients = [];
				}
				this.loading = loading;
				this.loadingModule = loadingModule;
			});
	}

	closeModalAlert(event: any) {
		//Se cierra el modal donde se toma la decision si se elimina o el no elemento seleccionado
		if (event.resp && event.value === 'deleteClients') {
			this.store.dispatch(deleteClient({ ...this.clientSelectedDelete }));
		} else if (event.resp && event.value === 'deleteModule') {
			const params = {
				sk: this.clientSelect.sk,
				pk: this.clientSelect.pk,
			};
			this.store.dispatch(deleteModuleOneClient({ params, data: this.moduleClientDeleteSelected }));
		}
		this.openAlert = false;
	}

	selectClientView(client: Client) {
		//Se selecciona un cliente
		this.clientSelect = client;
		this.clientSelect.module = this.clientSelect.module.map((module) => {
			return {
				...module,
				logo: module?.logo ? module?.logo.replace('s3.amazonaws.com/', '') : '',
			};
		});
		this.breadcrumb.push({ id: [client.pk], text: client.name });
		this.isClientSelect = true;
		this.store.dispatch(getModuleOneClient({ pk: this.clientSelect.pk, sk: this.clientSelect.sk }));
		this.searchClient = '';
	}
	selectModuleView(module: ModuleClient) {
		//Se selecciona un modulo
		if (this.moduleSelect?.customModuleSk === module.customModuleSk) {
			this.moduleSelect = {} as ModuleClient;
			this.isModuleSelect = false;
			this.breadcrumb.splice(1, 1);
		} else {
			this.moduleSelect = module;
			this.isModuleSelect = true;
			if (this.breadcrumb.length === 2) {
				this.breadcrumb.splice(1, 1, {
					id: [module.customModuleSk],
					text: module.custom_name_module,
				});
			} else {
				this.breadcrumb.push({ id: [module.customModuleSk], text: module.custom_name_module });
			}
		}
	}
	clearClientSelect() {
		//Se Limpia el subsidebar
		this.isModuleSelect = false;
		this.clientSelect = {} as Client;
		this.moduleSelect = {} as ModuleClient;
		this.isClientSelect = false;
		this.searchClient = '';
	}

	searchSidebar(search: string) {
		//Busqueda en el sidebar
		if (!this.isClientSelect) {
			this.store.dispatch(searchClient({ search }));
		} else {
			this.searchClient = search;
		}
	}
	deleteModuleClient(module: ModuleClient) {
		//Abre modal de eliminar un cliente
		this.elementsDelete = `${this.translateClients.deleteModule} '${module.custom_name_module}'`;
		this.valueModalDelete = 'deleteModule';
		this.openAlert = true;
		this.moduleClientDeleteSelected = {
			sk: module.moduleSk,
			pk: module.modulePk,
			custom_name_module: module.custom_name_module,
		} as ModuleClient;
	}

	getFirstWord(word: string): string {
		const textArray = word.split(' ');
		return textArray[0];
	}

	getCounttWords(word: string): boolean {
		const textArray = word.split(' ');
		return textArray.length > 1 ? true : false;
	}

	itemsClients(clients: Client[]) {
		this.clients = clients.map((client) => {
			//Se agrega los items para el menu popover
			return {
				...client,
				logo: client?.logo ? client?.logo.replace('s3.amazonaws.com/', '') : '',
				module: client?.module.map((module) => {
					return {
						...module,
						logo: module?.logo ? module?.logo.replace('s3.amazonaws.com/', '') : '',
					};
				}),
				items: [
					{
						label: this.translateClients.buttonEdit,
						icon: 'pi pi-pencil',
						command: () => {
							this.openDialogclient('edit', client);
						},
					},
					{
						label: this.translateClients.buttonDelete,
						icon: 'pi pi-trash',
						command: () => {
							this.clientSelectedDelete = { pk: client.pk, sk: client.sk };
							this.valueModalDelete = 'deleteClients';
							this.elementsDelete = `${this.translateClients.deleteClient} '${client.name}'`;
							this.openAlert = true;
						},
					},
				],
			};
		});
		if (!this.isModuleSelect && this.clientSelect?.module && this.clientSelect?.module.length > 0) {
			this.selectModuleView(this.clientSelect?.module[0]);
		}
	}

	selecteBreadCrumbd(selected: IBreadcrumb) {
		if (selected.id[0] === 'clientsView') {
			this.clearClientSelect();
			this.breadcrumb = [];
		}
		if (selected.id[0].includes('clients')) {
			this.breadcrumb.splice(1, 1);
			this.moduleSelect = {} as ModuleClient;
			this.isModuleSelect = false;
		}
	}
}
